import { create } from "zustand"

import type { QualityRequestSearchParams } from "../schemas"

import type { GetQualityRequestListQuery, QualityApproval } from "@/graphql/codegen/graphql"
import { GetQualityRequestListDocument } from "@/graphql/codegen/graphql"
import { createSearchStore } from "@/stores/createSearchStore"

export type QualityRequestSearchFilters = QualityRequestSearchParams

interface QualityRequestQueryInput {
  filter: { query?: string; status: QualityRequestSearchParams["status"] }
  sort: { field: QualityRequestSearchParams["field"]; order: QualityRequestSearchParams["order"] }
  offset: number
  limit: number
}

const deduplicateQualityRequests = (newData: QualityApproval[], existingData: QualityApproval[]): QualityApproval[] => {
  const uniqueIds = new Set(existingData.map((qualityApproval) => qualityApproval.qualityApprovalId))
  return [...existingData, ...newData.filter((qualityApproval) => !uniqueIds.has(qualityApproval.qualityApprovalId))]
}

export const useQualityRequestSearchStore = create(
  createSearchStore<QualityApproval, QualityRequestSearchFilters, GetQualityRequestListQuery>({
    documentNode: GetQualityRequestListDocument,
    deduplicateData: deduplicateQualityRequests,
    getQueryInput: (filters: QualityRequestSearchFilters, offset: number, limit: number): QualityRequestQueryInput => {
      const { field, order, query, status } = filters
      return {
        filter: { query, status },
        sort: { field, order },
        offset,
        limit,
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => {
      const output = data.dashboard.qualityRequestList
      return {
        __typename: output.__typename,
        data: output.__typename === "QualityApprovalListSuccess" ? (output.qualityApprovals as QualityApproval[]) : [],
        error: output.__typename === "QualityApprovalListFailure" ? output.error : undefined,
      }
    },
  })
)
